module.exports = {
  dashboardUrl: 'https://crm.supersaravanastores.com',
  ruleServerUrl: 'https://classic.api.crm.supersaravanastores.com',
  casaWebAppUrl: 'https://web.crm.supersaravanastores.com',
  apiServerUrl: 'https://api.crm.supersaravanastores.com',
  casaEcomUrl: 'https://ecom.crm.supersaravanastores.com',
  casaBeatUrl: 'https://beat.crm.supersaravanastores.com',
  pwaUrl: 'https://pwa.crm.supersaravanastores.com',
  dashboard: 'https://crm.supersaravanastores.com',
  ruleUiUrl: 'https://rule.crm.supersaravanastores.com',
  commerceConnect: 'https://commerce-connect-up.crm.supersaravanastores.com',
  turnedOffFeatures: [],
  keycloakConfig: {
    url: `https://auth.crm.supersaravanastores.com/auth`,
    realm: `casa`,
    clientId: `casa_web_app`
  }
};
